import { FolderOutlineOpenIcon } from '@tableau/icons/FolderOutlineOpenIcon';
import { SpotFolderOutlineOpenIcon } from '@tableau/icons/SpotFolderOutlineOpenIcon';
import React from 'react';
import { call } from 'redux-saga/effects';

import { ServerFilterClauses } from '~commonInfra/utils/ServerFilterClauses';
import { Messages } from '~src/codegen/Localize';
import { imgPath } from '~src/commonInfra/utils/ImgUrl';
import { Projects } from '~src/projects/resources/Projects';
import { SpacesSiteUrls } from '~src/spacesPlatform/components/spaceComponents/SpacesSiteUrls';
import {
  ContentTypeFilterClause,
  MixedContentItemDefinition,
  SpaceDefinition
} from '~src/spacesPlatform/contentDefinitionInterfaces/ContentDefinitionsTypes';
import { ContentFiltersKeys } from '~src/spacesPlatform/models/ContentFilters';
import { ProjectContentType } from '~src/spacesPlatform/models/ContentTypes';
import { IContentInfo } from '~src/spacesPlatform/models/IContentInfo';
import { getProjectInfos } from '~src/spacesPlatform/sagas/SpacesSagaHelpers';
import { NullProjectIdForNonProjects } from '~src/spacesPlatform/state/SpaceInfo';

import { IProjectInfo } from '../../models/IProjectInfo';
import { IProjectActions } from '../../ServerApi/types/IProjectActions';
import { ProjectCard } from '../ProjectCard';
import { ConnectedProjectDetailsDialogBody } from '../ProjectDetailsDialog';


export const ProjectDefinition: MixedContentItemDefinition & SpaceDefinition<'project'> = {
  itemType: 'project',
  contentType: 'project',
  singularName: Messages.project,
  pluralName: Messages.projects,
  emptyStateMessage: Messages.projectsEmptyMessage,
  siteFilterByTypeDropdownName: Messages.siteFilterByTypeDropdown_Projects,
  contentFilterKeys: ProjectContentType.filterKeys,
  defaultFilters: getProjectDefaultFilters,
  cardComponent: ProjectCard,
  listViewIconType: FolderOutlineOpenIcon,
  filterClause: ServerFilterClauses.ContentType(['project']) as ContentTypeFilterClause,
  contentSpaceUrl: (urls: SpacesSiteUrls, contentId: string) => urls.projectUrl(contentId),
  getBasicQuery: () => Projects.all(),
  fieldValueResourceType: 'project',
  getContentInfo: (contentList: IContentInfo[]) => call(getProjectInfos, contentList),
  headerIconPath: () => imgPath('spaces_masthead_project.svg'),
  headerIconNode: () => <SpotFolderOutlineOpenIcon size={60} alt='' />,
  supportedDisplayModes: ['list', 'thumbnail'],
  detailDialogTitle: Messages.projectDetailsTitle,
  detailDialogBody: (content: IContentInfo<'project'>, availableActions: IProjectActions) => {
    return (
      <ConnectedProjectDetailsDialogBody
        project={content as IProjectInfo}
        allowedActions={availableActions}
      />
    );
  },
};

function getProjectDefaultFilters(projectId: string) {
  if (projectId === NullProjectIdForNonProjects) {
    const filterClause = ServerFilterClauses.serverFilterClauses[ContentFiltersKeys.allProjects];
    return {allProjects: filterClause('false')};
  } else {
    return {parentProject: ServerFilterClauses.create({parentProject: projectId})[0]};
  }
}
